module.exports = __webpack_public_path__ + "templates/about.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/about/templates/about.html
// module id = NVGt
// module chunks = 1